/** Perfiles limitados del equipo de un organizador (coadmin, capturista,
 * finanzas). Los dueños y co-admins legacy de poder total no se administran
 * desde las pantallas de Equipo. */
export const TEAM_PROFILE_OPTIONS: Array<{ value: "coadmin" | "capturista" | "finanzas" | "arbitro"; label: string; hint: string }> = [
  {
    value: "coadmin",
    label: "Coadministrador",
    hint: "Coadmin: puede hacer todo lo que tú en los torneos asignados, menos borrarlos.",
  },
  {
    value: "capturista",
    label: "Capturista",
    hint: "Solo programar partidos y capturar resultados. No puede tocar jugadores, draw ni cobros.",
  },
  {
    value: "finanzas",
    label: "Finanzas",
    hint: "Solo inscripciones y pagos: registrar pagos, validar comprobantes y cobrar.",
  },
  {
    value: "arbitro",
    label: "Árbitro",
    hint: "Solo ve y captura los partidos que le asignes en «Árbitros». No ve inscripciones, pagos, draw ni otras categorías.",
  },
];

export function isLimitedTeamProfile(value: string): value is "coadmin" | "capturista" | "finanzas" | "arbitro" {
  return value === "coadmin" || value === "capturista" || value === "finanzas" || value === "arbitro";
}
